{
  "SHORT KEY": "TRANSLATION SYSTEM KEY",

  "panel_header_title_list": "Animation_panel_header_title_add",

  "section_entrance": "Animation_panel_accordion_category_header_entrance",
  "section_ongoing": "Animation_panel_accordion_category_header_loop",
  "section_scroll": "Animation_panel_accordion_category_header_scroll",

  "section_entrance_hover": "Animation_panel_accordion_category_header_entrance_tooltip",
  "section_ongoing_hover": "Animation_panel_accordion_category_header_loop_tooltip",
  "section_scroll_hover": "Animation_panel_accordion_category_header_scroll_tooltip",

  "panel_header_title_settings": "Animation_panel_header_settings_title",
  "panel_header_preset_title_settings": "Animation_panel_header_preset_settings_title",

  "customize_button": "ANIMATION_PANEL_CUSTOMIZE_BUTTON",
  "apply_from_desktop_button": "Animation_panel_settings_reset_override_CTA",
  "apply_from_desktop_tooltip": "Animation_panel_settings_reset_override_tooltip",

  "name_none": "ANIMATION_NAME_NONE",
  "name_bouncein": "Animation_name_bounce",
  "name_fadein": "Animation_name_fade",
  "name_glidein": "Animation_name_glide",
  "name_glitchin": "Animation_name_glide",
  "name_expandin": "Animation_name_expand",
  "name_floatin": "Animation_name_float",
  "name_spinin": "Animation_name_spin",
  "name_turnin": "Animation_name_turn",
  "name_arcin": "Animation_name_arc",
  "name_puffin": "Animation_name_puff",
  "name_foldin": "Animation_name_fold",
  "name_flipin": "Animation_name_flip",
  "name_revealin": "ANIMATION_NAME_REVEAL",
  "name_slidein": "Animation_name_slide",
  "name_shapein": "Animation_name_shape",
  "name_winkin": "Animation_name_wink",
  "name_tiltin": "Animation_name_tilt",
  "name_blurin": "Animation_name_blur",
  "name_dropin": "Animation_name_drop",
  "name_growin": "Animation_name_grow",

  "name_circlein": "Animation_name_circle",
  "name_curvein": "Animation_name_curve",
  "name_flyin": "Animation_name_fly",
  "name_punchin": "Animation_name_punch",

  "name_bounce": "Animation_name_bounce",
  "name_breathe": "Animation_name_breathe",
  "name_flip": "Animation_name_flip",
  "name_fold": "Animation_name_fold",
  "name_cross": "Animation_name_cross",
  "name_spin": "Animation_name_spin",
  "name_flash": "Animation_name_flash",
  "name_jello": "Animation_name_jello",
  "name_poke": "Animation_name_poke",
  "name_pulse": "Animation_name_pulse",
  "name_rubber": "Animation_name_rubber",
  "name_wiggle": "Animation_name_wiggle",
  "name_swing": "Animation_name_swing",

  "name_arcscroll": "Animation_name_arc",
  "name_blurscroll": "Animation_name_blur",
  "name_fadescroll": "Animation_name_fade",
  "name_flipscroll": "Animation_name_flip",
  "name_growscroll": "Animation_name_grow",
  "name_movescroll": "Animation_name_move",
  "name_panscroll": "Animation_name_pan",
  "name_parallaxscroll": "Animation_name_parallax",
  "name_revealscroll": "ANIMATION_NAME_REVEAL",
  "name_shapescroll": "Animation_name_shape",
  "name_shrinkscroll": "Animation_name_shrink",
  "name_skewpanscroll": "Animation_name_skewpan",
  "name_slidescroll": "Animation_name_slide",
  "name_spin3dscroll": "Animation_name_spin3d",
  "name_spinscroll": "Animation_name_spin",
  "name_stretchscroll": "Animation_name_stretch",
  "name_tiltscroll": "Animation_name_tilt",
  "name_turnscroll": "Animation_name_turn",

  "enum_soft": "Animation_panel_settings_dropdown_gentle",
  "enum_medium": "Animation_panel_settings_dropdown_moderate",
  "enum_hard": "Animation_panel_settings_dropdown_intense",

  "enum_ellipse": "Animation_panel_settings_shape_dropdown_elipse",
  "enum_circle": "Animation_panel_settings_shape_dropdown_circle",
  "enum_rectangle": "Animation_panel_settings_shape_dropdown_rectangle",
  "enum_diamond": "Animation_panel_settings_shape_dropdown_diamond",
  "enum_window": "Animation_panel_settings_shape_dropdown_arch",

  "enum_clockwise": "Animation_panel_settings_dropdown_direction_clockwise",
  "enum_counter-clockwise": "Animation_panel_settings_dropdown_direction_counterclockwise",

  "enum_horizontal": "Animation_panel_settings_wink_dropdown_direction_horizontal",
  "enum_vertical": "Animation_panel_settings_wink_dropdown_direction_vertical",

  "enum_left": "Animation_panel_settings_direction_left",
  "enum_right": "Animation_panel_settings_direction_right",
  "enum_bottom": "Animation_panel_settings_direction_bottom",
  "enum_top": "Animation_panel_settings_direction_top",
  "enum_bottom-left": "Animation_panel_settings_direction_bottom_left",
  "enum_bottom-right": "Animation_panel_settings_direction_bottom_right",
  "enum_top-left": "Animation_panel_settings_direction_top_left",
  "enum_top-right": "Animation_panel_settings_direction_top_right",
  "enum_center": "Animation_panel_settings_direction_center",

  "enum_in": "Animation_panel_settings_scroll_track_in",
  "enum_out": "Animation_panel_settings_scroll_track_out",
  "enum_continuous": "Animation_panel_settings_scroll_track_Continuous",

  "enum_30": "Animation_panel_settings_scroll_angle_30",
  "enum_60": "Animation_panel_settings_scroll_angle_60",
  "enum_120": "Animation_panel_settings_scroll_angle_120",
  "enum_150": "Animation_panel_settings_scroll_angle_150",
  "enum_210": "Animation_panel_settings_scroll_angle_210",
  "enum_240": "Animation_panel_settings_scroll_angle_240",
  "enum_300": "Animation_panel_settings_scroll_angle_300",
  "enum_330": "Animation_panel_settings_scroll_angle_330",

  "label_entrance_direction": "Animation_panel_settings_direction_label",
  "label_entrance_startfromoffscreen": "Animation_panel_settings_start_off_screen_checkbox",
  "label_entrance_duration": "Animation_panel_settings_slider_duration",
  "label_entrance_distance": "Animation_panel_settings_slider_distance_label",
  "label_entrance_delay": "Animation_panel_settings_slider_entrance_delay",
  "label_entrance_power": "Animation_panel_settings_dropdown_style",
  "label_entrance_spins": "Animation_panel_settings_slider_spins",
  "label_entrance_shape": "Animation_panel_settings_shape_dropdown",

  "label_ongoing_direction": "Animation_panel_settings_direction_label",
  "label_ongoing_startfromoffscreen": "Animation_panel_settings_start_off_screen_checkbox",
  "label_ongoing_duration": "Animation_panel_settings_slider_duration",
  "label_ongoing_distance": "Animation_panel_settings_slider_distance_label",
  "label_ongoing_delay": "Animation_panel_settings_slider_loop_delay",
  "label_ongoing_power": "Animation_panel_settings_dropdown_style",
  "label_ongoing_spins": "Animation_panel_settings_slider_spins",
  "label_ongoing_shape": "Animation_panel_settings_shape_dropdown",

  "label_scroll_in_direction": "Animation_panel_settings_direction_label",
  "label_scroll_in_startfromoffscreen": "Animation_panel_settings_start_off_screen_checkbox",
  "label_scroll_in_distance": "Animation_panel_settings_slider_distance_label",
  "label_scroll_in_power": "Animation_panel_settings_dropdown_style",
  "label_scroll_in_spins": "Animation_panel_settings_slider_spins",
  "label_scroll_in_shape": "Animation_panel_settings_shape_dropdown",

  "label_scroll_in_track": "Animation_panel_settings_scroll_track_label",
  "label_scroll_in_end": "Animation_panel_settings_scroll_end_label",
  "label_scroll_in_start": "Animation_panel_settings_scroll_start_label",
  "label_scroll_in_angle": "Animation_panel_settings_scroll_angle_label",
  "label_scroll_in_spin": "Animation_panel_settings_scroll_spin_label",
  "label_scroll_in_range": "Animation_panel_settings_scroll_range_label",
  "label_scroll_in_speed": "Animation_panel_settings_scroll_speed_label",

  "enum_scroll_in_clockwise": "Animation_panel_settings_dropdown_direction_clockwise",
  "enum_scroll_in_counter-clockwise": "Animation_panel_settings_dropdown_direction_counterclockwise",
  "enum_scroll_in_horizontal": "Animation_panel_settings_wink_dropdown_direction_horizontal",
  "enum_scroll_in_vertical": "Animation_panel_settings_wink_dropdown_direction_vertical",
  "enum_scroll_in_left": "Animation_panel_settings_direction_left",
  "enum_scroll_in_right": "Animation_panel_settings_direction_right",
  "enum_scroll_in_bottom": "Animation_panel_settings_direction_bottom",
  "enum_scroll_in_top": "Animation_panel_settings_direction_top",
  "enum_scroll_in_bottom-left": "Animation_panel_settings_direction_bottom_left",
  "enum_scroll_in_bottom-right": "Animation_panel_settings_direction_bottom_right",
  "enum_scroll_in_top-left": "Animation_panel_settings_direction_top_left",
  "enum_scroll_in_top-right": "Animation_panel_settings_direction_top_right",
  "enum_scroll_in_center": "Animation_panel_settings_direction_center",

  "label_scroll_out_direction": "Animation_panel_settings_direction_label",
  "label_scroll_out_startfromoffscreen": "Animation_panel_settings_end_off_screen_checkbox",
  "label_scroll_out_distance": "Animation_panel_settings_slider_distance_label",
  "label_scroll_out_power": "Animation_panel_settings_dropdown_style",
  "label_scroll_out_spins": "Animation_panel_settings_slider_spins",
  "label_scroll_out_shape": "Animation_panel_settings_shape_dropdown",

  "label_scroll_out_track": "Animation_panel_settings_scroll_track_label",
  "label_scroll_out_end": "Animation_panel_settings_scroll_end_label",
  "label_scroll_out_start": "Animation_panel_settings_scroll_start_label",
  "label_scroll_out_angle": "Animation_panel_settings_scroll_angle_label",
  "label_scroll_out_spin": "Animation_panel_settings_scroll_spin_label",
  "label_scroll_out_range": "Animation_panel_settings_scroll_range_label",
  "label_scroll_out_speed": "Animation_panel_settings_scroll_speed_label",

  "enum_scroll_out_clockwise": "Animation_panel_settings_dropdown_direction_clockwise",
  "enum_scroll_out_counter-clockwise": "Animation_panel_settings_dropdown_direction_counterclockwise",
  "enum_scroll_out_horizontal": "Animation_panel_settings_wink_dropdown_direction_horizontal",
  "enum_scroll_out_vertical": "Animation_panel_settings_wink_dropdown_direction_vertical",
  
  "enum_scroll_out_left": "Animation_panel_settings_direction_to_left",
  "enum_scroll_out_right": "Animation_panel_settings_direction_to_right",
  "enum_scroll_out_bottom": "Animation_panel_settings_direction_to_bottom",
  "enum_scroll_out_top": "Animation_panel_settings_direction_to_top",
  "enum_scroll_out_bottom-left": "Animation_panel_settings_direction_to_bottom_left",
  "enum_scroll_out_bottom-right": "Animation_panel_settings_direction_to_bottom_right",
  "enum_scroll_out_top-left": "Animation_panel_settings_direction_to_top_left",
  "enum_scroll_out_top-right": "Animation_panel_settings_direction_to_top_right",
  "enum_scroll_out_center": "Animation_panel_settings_direction_to_center",

  "label_scroll_continuous_direction": "Animation_panel_settings_direction_label",
  "label_scroll_continuous_startfromoffscreen": "Animation_panel_settings_start_end_off_screen_checkbox",
  "label_scroll_continuous_distance": "Animation_panel_settings_slider_distance_label",
  "label_scroll_continuous_power": "Animation_panel_settings_dropdown_style",
  "label_scroll_continuous_spins": "Animation_panel_settings_slider_spins",
  "label_scroll_continuous_shape": "Animation_panel_settings_shape_dropdown",

  "label_scroll_continuous_track": "Animation_panel_settings_scroll_track_label",
  "label_scroll_continuous_end": "Animation_panel_settings_scroll_end_label",
  "label_scroll_continuous_start": "Animation_panel_settings_scroll_start_label",
  "label_scroll_continuous_angle": "Animation_panel_settings_scroll_angle_label",
  "label_scroll_continuous_spin": "Animation_panel_settings_scroll_spin_label",
  "label_scroll_continuous_range": "Animation_panel_settings_scroll_range_label",
  "label_scroll_continuous_speed": "Animation_panel_settings_scroll_speed_label",

  "enum_scroll_continuous_clockwise": "Animation_panel_settings_dropdown_direction_clockwise",
  "enum_scroll_continuous_counter-clockwise": "Animation_panel_settings_dropdown_direction_counterclockwise",
  "enum_scroll_continuous_horizontal": "Animation_panel_settings_wink_dropdown_direction_horizontal",
  "enum_scroll_continuous_vertical": "Animation_panel_settings_wink_dropdown_direction_vertical",
  "enum_scroll_continuous_left": "Animation_panel_settings_direction_left",
  "enum_scroll_continuous_right": "Animation_panel_settings_direction_right",
  "enum_scroll_continuous_bottom": "Animation_panel_settings_direction_bottom",
  "enum_scroll_continuous_top": "Animation_panel_settings_direction_top",
  "enum_scroll_continuous_bottom-left": "Animation_panel_settings_direction_bottom_left",
  "enum_scroll_continuous_bottom-right": "Animation_panel_settings_direction_bottom_right",
  "enum_scroll_continuous_top-left": "Animation_panel_settings_direction_top_left",
  "enum_scroll_continuous_top-right": "Animation_panel_settings_direction_top_right",
  "enum_scroll_continuous_center": "Animation_panel_settings_direction_center",

  "label_preview": "Animation_panel_settings_preview_label",
  "label_preview_scroll": "Animation_panel_settings_scroll_preview_label",
  "tooltip_preview_scroll": "Animation_panel_settings_scroll_preview_tooltip",

  "section_entrance_remove_others_message": "Animation_panel_entrance_remove_others_message",
  "section_ongoing_remove_others_message": "Animation_panel_loop_remove_others_message",
  "section_scroll_remove_others_message": "Animation_panel_scroll_remove_others_message",

  "section_entrance_legacy_message": "Animation_panel_deprecated_animation_info_text",
  "section_entrance_legacy_message_link": "Animation_panel_deprecated_animation_info_text_help_link"
}
